import { useQueryClient } from '@tanstack/react-query';
import { lazy, Suspense, useEffect, useState } from 'react';

const LazyDevTools = lazy(() =>
  Promise.all([
    import('@tanstack/react-query-devtools/production'),
    import('@tanstack/router-devtools'),
  ]).then(([{ ReactQueryDevtools }, { TanStackRouterDevtools }]) => {
    const Component = () => {
      const queryClient = useQueryClient();

      return (
        <>
          <ReactQueryDevtools
            buttonPosition="bottom-right"
            client={queryClient}
          />
          <TanStackRouterDevtools position="bottom-left" />
        </>
      );
    };

    return { default: Component };
  }),
);

export const DevTools = (): JSX.Element => {
  const [showDevtools, setShowDevtools] = useState(import.meta.env.DEV);

  useEffect(() => {
    Object.assign(window, {
      toggleDevtools: () => setShowDevtools(old => !old),
    });
  }, []);

  return showDevtools ? (
    <Suspense fallback={null}>
      <LazyDevTools />
    </Suspense>
  ) : (
    <></>
  );
};
